"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDayRevenue = fetchDayRevenue;
exports.tokensRevenueToUsdRevenue = tokensRevenueToUsdRevenue;
exports.fetchLastSevenDaysRevenue = fetchLastSevenDaysRevenue;
exports.putDailyRevenueToDynamoDB = putDailyRevenueToDynamoDB;
exports.getDailyRevenueDataFromDynamoDB = getDailyRevenueDataFromDynamoDB;
exports.getDailyRevenueLastDateFromDynamoDB = getDailyRevenueLastDateFromDynamoDB;
exports.getEndOfDayGMT = getEndOfDayGMT;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const decimal_js_1 = require("decimal.js");
const TVL_js_1 = require("./TVL.js");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const index_js_1 = require("../index.js");
const logger_js_1 = require("../../logger.js");
const DAILY_REVENUE_TABLE_NAME = process.env.DAILY_REVENUE_TABLE_NAME;
async function fetchDayRevenue(params) {
    const revenueObjects = [];
    const { startTime, endTime } = params;
    const singleAssetRevenueMap = {};
    const doubleAssetRevenueMap = {};
    const multiAssetRevenueMap = {};
    const autocompoundEvents = await (0, alphafi_sdk_1.fetchAutoCompoundingEvents)({
        startTime,
        endTime,
    });
    const investorMap = (0, alphafi_sdk_1.getInvestorPoolMap)();
    const ten = new decimal_js_1.Decimal(10);
    autocompoundEvents.forEach((event) => {
        if ("compound_amount_a" in event && "compound_amount_b" in event) {
            // CETUS
            const pool = investorMap.get(event.investor_id);
            if (!pool)
                throw new Error(`pool not found for investor ${event.investor_id}`);
            const { coinA, coinB } = (0, alphafi_sdk_1.coinsInPool)(pool);
            const time = getEndOfDayGMT(event.timestamp);
            const coinAAmount = new decimal_js_1.Decimal(event.fee_collected_a.toString()).div(ten.pow(alphafi_sdk_1.coinsList[coinA].expo));
            const coinBAmount = new decimal_js_1.Decimal(event.fee_collected_b.toString()).div(ten.pow(alphafi_sdk_1.coinsList[coinB].expo));
            if (!doubleAssetRevenueMap[time])
                doubleAssetRevenueMap[time] = {};
            if (!doubleAssetRevenueMap[time][pool])
                doubleAssetRevenueMap[time][pool] = {
                    coinAAmount: new decimal_js_1.Decimal(0),
                    coinBAmount: new decimal_js_1.Decimal(0),
                };
            doubleAssetRevenueMap[time][pool].coinAAmount =
                doubleAssetRevenueMap[time][pool].coinAAmount?.add(coinAAmount);
            doubleAssetRevenueMap[time][pool].coinBAmount =
                doubleAssetRevenueMap[time][pool].coinBAmount?.add(coinBAmount);
        }
        else if ("compound_amount" in event && !("cur_total_debt" in event)) {
            // NAVI, BUCKET-BUCK
            const pool = investorMap.get(event.investor_id);
            if (!pool)
                throw new Error(`pool not found for investor ${event.investor_id}`);
            const time = getEndOfDayGMT(event.timestamp);
            const coin = (0, alphafi_sdk_1.coinsInPool)(pool);
            const coinAmount = new decimal_js_1.Decimal(event.fee_collected.toString()).div(ten.pow(alphafi_sdk_1.coinsList[coin].expo));
            if (!singleAssetRevenueMap[time])
                singleAssetRevenueMap[time] = {};
            if (!singleAssetRevenueMap[time][pool])
                singleAssetRevenueMap[time][pool] = {
                    coinAmount: new decimal_js_1.Decimal(0),
                };
            singleAssetRevenueMap[time][pool].coinAmount =
                singleAssetRevenueMap[time][pool].coinAmount?.add(coinAmount);
        }
        else if ("cur_total_debt" in event) {
            // NAVI-LOOP, ALPHALEND
            const pool = investorMap.get(event.investor_id);
            if (!pool)
                throw new Error(`pool not found for investor ${event.investor_id}`);
            const coin = (0, alphafi_sdk_1.coinsInPool)(pool);
            const time = getEndOfDayGMT(event.timestamp);
            const coinAmount = new decimal_js_1.Decimal(event.fee_collected.toString()).div(ten.pow(alphafi_sdk_1.coinsList[coin].expo));
            if (!singleAssetRevenueMap[time])
                singleAssetRevenueMap[time] = {};
            if (!singleAssetRevenueMap[time][pool])
                singleAssetRevenueMap[time][pool] = {
                    coinAmount: new decimal_js_1.Decimal(0),
                };
            singleAssetRevenueMap[time][pool].coinAmount =
                singleAssetRevenueMap[time][pool].coinAmount?.add(coinAmount);
        }
        else if ("amount" in event && !("total_amount_a" in event)) {
            // ALPHA
            const coinAmount = new decimal_js_1.Decimal(event.amount)
                .mul(new decimal_js_1.Decimal(0.2))
                .div(ten.pow(alphafi_sdk_1.coinsList["ALPHA"].expo));
            const pool = "ALPHA";
            const time = getEndOfDayGMT(event.timestamp);
            if (!singleAssetRevenueMap[time])
                singleAssetRevenueMap[time] = {};
            if (!singleAssetRevenueMap[time][pool])
                singleAssetRevenueMap[time][pool] = {
                    coinAmount: new decimal_js_1.Decimal(0),
                };
            singleAssetRevenueMap[time][pool].coinAmount =
                singleAssetRevenueMap[time][pool].coinAmount?.add(coinAmount);
        }
        else if ("blue_reward_amount" in event) {
            // BLUEFIN AUTOBALANCE POOLS OLD
            const pool = investorMap.get(event.investor_id);
            if (!pool)
                throw new Error(`pool not found for investor ${event.investor_id}`);
            const time = getEndOfDayGMT(event.timestamp);
            // AutoBalance pools give Blue as earning
            const coinAmount = new decimal_js_1.Decimal(event.fee_collected.toString()).div(ten.pow(alphafi_sdk_1.coinsList.BLUE.expo));
            if (!singleAssetRevenueMap[time])
                singleAssetRevenueMap[time] = {};
            if (!singleAssetRevenueMap[time][pool])
                singleAssetRevenueMap[time][pool] = { coinAmount: new decimal_js_1.Decimal(0) };
            singleAssetRevenueMap[time][pool].coinAmount =
                singleAssetRevenueMap[time][pool].coinAmount?.add(coinAmount);
        }
        else if ("amount" in event && "total_amount_a" in event) {
            // BLUEFIN AUTOBALANCE POOLS NEW
            const pool = investorMap.get(event.investor_id);
            if (!pool)
                throw new Error(`pool not found for investor ${event.investor_id}`);
            const time = getEndOfDayGMT(event.timestamp);
            // buggy events patch
            if (event.coin_type.name ===
                "dd5c4badc89f08fb2ff3c1827411c9bafbed54c64c17d8ab969f637364ca8b4f::blue::BLUE" ||
                event.coin_type.name ===
                    "9753a815080c9a1a1727b4be9abb509014197e78ae09e33c146c786fac3731e0::bpoint::BPOINT") {
                return;
            }
            const coinType = `0x${event.coin_type.name}`;
            if (!coinType) {
                (0, logger_js_1.logError)("Coin type not found for autobalance pool, skipping in revenue calculation", {
                    component: "dailyRevenue",
                    operation: "fetchDayRevenue",
                    context: { event },
                });
                return;
            }
            const coin = Object.values(alphafi_sdk_1.coinsList).find((coin) => coin.type === coinType);
            if (!coin) {
                (0, logger_js_1.logWarning)("Coin not found for autobalance pool, skipping in revenue calculation", {
                    component: "dailyRevenue",
                    operation: "fetchDayRevenue",
                    context: { event },
                });
                return;
            }
            const fee = new decimal_js_1.Decimal(event.fee_collected.toString()).div(ten.pow(coin.expo));
            if (!multiAssetRevenueMap[time])
                multiAssetRevenueMap[time] = {};
            if (!multiAssetRevenueMap[time][pool])
                multiAssetRevenueMap[time][pool] = {};
            if (!multiAssetRevenueMap[time][pool][coin.name])
                multiAssetRevenueMap[time][pool][coin.name] = new decimal_js_1.Decimal(0);
            multiAssetRevenueMap[time][pool][coin.name] =
                multiAssetRevenueMap[time][pool][coin.name]?.add(fee);
        }
        else {
            (0, logger_js_1.logError)("Unhandled events found in autocompounding events", {
                component: "dailyRevenue",
                operation: "fetchDayRevenue",
                context: { event },
            });
            throw new Error("Unhandled events found");
        }
    });
    // No more looping pools withdrawl fee or deposit fee
    // add Single Loop strategies if using this again
    // // NAVI-LOOP withdrawl fee
    // const loopingPoolNames = Object.keys(poolInfo)
    //   .filter((pool) => poolInfo[pool].strategyType === "LOOPING")
    //   .map((pool) => pool as PoolName);
    // const liquidityChangeEvents = await fetchLiquidityChangeEvents({
    //   startTime,
    //   endTime,
    //   poolNames: loopingPoolNames,
    // });
    // liquidityChangeEvents.forEach((event) => {
    //   if ("amount" in event) {
    //     // NAVI, NAVI-LOOP, ALPHA
    //     const pool = poolIdPoolNameMap[event.pool_id] as SingleAssetPoolNames;
    //     const coin = coinsInPool(pool as SingleAssetPoolNames, {
    //       event_type: event.event_type,
    //       type: event.type,
    //     });
    //     const time = getEndOfDayGMT(event.timestamp);
    //     const coinAmount = new Decimal(event.fee_collected).div(
    //       ten.pow(coinsList[coin].expo),
    //     );
    //     if (!singleAssetRevenueMap[time]) singleAssetRevenueMap[time] = {};
    //     if (!singleAssetRevenueMap[time][pool])
    //       singleAssetRevenueMap[time][pool] = {
    //         coinAmount: new Decimal(0),
    //       };
    //     singleAssetRevenueMap[time][pool].coinAmount =
    //       singleAssetRevenueMap[time][pool].coinAmount?.add(coinAmount);
    //   }
    // });
    // ALPHA Instant unstake fees
    const withdrawV2Events = await (0, alphafi_sdk_1.fetchWithdrawV2Events)({ startTime, endTime });
    withdrawV2Events.forEach((event) => {
        // ignore instant unstake by organisation wallets
        if ("instant_withdraw_fee_collected" in event &&
            !alphafi_sdk_1.ignoredWalletsForDailyRevenue.includes(event.sender)) {
            // ALPHA
            const time = getEndOfDayGMT(event.timestamp);
            const alphaAmount = new decimal_js_1.Decimal(event.fee_collected).div(1e9);
            if (!singleAssetRevenueMap[time])
                singleAssetRevenueMap[time] = {};
            if (!singleAssetRevenueMap[time]["ALPHA"])
                singleAssetRevenueMap[time]["ALPHA"] = {
                    coinAmount: new decimal_js_1.Decimal(0),
                };
            singleAssetRevenueMap[time]["ALPHA"].coinAmount =
                singleAssetRevenueMap[time]["ALPHA"].coinAmount?.add(alphaAmount);
        }
    });
    for (const time in singleAssetRevenueMap) {
        const poolRevenue = singleAssetRevenueMap[time];
        for (const poolName in poolRevenue) {
            const revenue = poolRevenue[poolName];
            if (!revenue) {
                (0, logger_js_1.logInfo)("Revenue not found for single asset poolName", {
                    component: "dailyRevenue",
                    operation: "fetchDayRevenue",
                    context: { poolName },
                });
                continue;
            }
            else {
                revenueObjects.push({
                    time: Number(time),
                    poolName: poolName,
                    coinAmount: revenue.coinAmount.toString(),
                });
            }
        }
    }
    for (const time in doubleAssetRevenueMap) {
        const poolRevenue = doubleAssetRevenueMap[time];
        for (const poolName in poolRevenue) {
            const revenue = poolRevenue[poolName];
            if (!revenue) {
                (0, logger_js_1.logInfo)("Revenue not found for double asset poolName", {
                    component: "dailyRevenue",
                    operation: "fetchDayRevenue",
                    context: { poolName },
                });
                continue;
            }
            else {
                revenueObjects.push({
                    time: Number(time),
                    poolName: poolName,
                    coinAAmount: revenue.coinAAmount.toString(),
                    coinBAmount: revenue.coinBAmount.toString(),
                });
            }
        }
    }
    for (const time in multiAssetRevenueMap) {
        const poolRevenue = multiAssetRevenueMap[time];
        for (const poolName in poolRevenue) {
            const revenue = poolRevenue[poolName];
            const parsedRevenue = {};
            for (const coinName in revenue) {
                parsedRevenue[coinName] =
                    revenue[coinName]?.toString() ?? "0";
            }
            revenueObjects.push({
                time: Number(time),
                poolName: poolName,
                coins: parsedRevenue,
            });
        }
    }
    return revenueObjects;
}
async function tokensRevenueToUsdRevenue(tokensRevenue) {
    const usdRevenue = [];
    let maxTime = Number.MIN_VALUE, minTime = Number.MAX_VALUE;
    const coinPairs = new Set();
    tokensRevenue.forEach((tokensRevenueObject) => {
        minTime = Math.min(minTime, tokensRevenueObject.time);
        maxTime = Math.max(maxTime, tokensRevenueObject.time);
        if ("coinAmount" in tokensRevenueObject) {
            if (alphafi_sdk_1.poolInfo[tokensRevenueObject.poolName].strategyType ===
                "AUTOBALANCE-LIQUIDITY-POOL") {
                // OLD BLUEFIN AUTOBALANCE POOLS
                coinPairs.add("BLUE/USD");
                if ("coinName" in tokensRevenueObject) {
                    coinPairs.add(`${tokensRevenueObject.coinName}/USD`);
                }
            }
            else {
                const coins = (0, alphafi_sdk_1.coinsInPool)(tokensRevenueObject.poolName);
                coinPairs.add(`${coins}/USD`);
            }
        }
        else if ("coinAAmount" in tokensRevenueObject) {
            const coins = (0, alphafi_sdk_1.coinsInPool)(tokensRevenueObject.poolName);
            coinPairs.add(`${coins.coinA}/USD`);
            coinPairs.add(`${coins.coinB}/USD`);
        }
        else if ("coins" in tokensRevenueObject) {
            // NEW BLUEFIN AUTOBALANCE POOLS
            for (const coinName in tokensRevenueObject.coins) {
                coinPairs.add(`${coinName}/USD`);
            }
        }
    });
    const historicalPrices = await (0, index_js_1.fetchHistoricalPrices)({
        maxTime,
        minTime,
        coinPairs: Array.from(coinPairs),
    });
    const promises = tokensRevenue.map(async (revenue) => {
        if (["CETUS", "BLUEFIN"].includes(alphafi_sdk_1.poolInfo[revenue.poolName].parentProtocolName) &&
            "coinAAmount" in revenue) {
            const { coinA, coinB } = (0, alphafi_sdk_1.coinsInPool)(revenue.poolName);
            const coinATimePricePair = historicalPrices[`${coinA}/USD`].find((pair) => {
                return Number(pair[0]) === Number(revenue.time);
            });
            const coinBTimePricePair = historicalPrices[`${coinB}/USD`].find((pair) => {
                return Number(pair[0]) === Number(revenue.time);
            });
            if (!coinATimePricePair) {
                (0, logger_js_1.logError)("Historical price not found for coin A in double asset pool", {
                    component: "dailyRevenue",
                    operation: "tokensRevenueToUsdRevenue",
                    context: {
                        poolName: revenue.poolName,
                        coin: coinA,
                        time: revenue.time,
                    },
                });
            }
            if (!coinBTimePricePair) {
                (0, logger_js_1.logError)("Historical price not found for coin B in double asset pool", {
                    component: "dailyRevenue",
                    operation: "tokensRevenueToUsdRevenue",
                    context: {
                        poolName: revenue.poolName,
                        coin: coinB,
                        time: revenue.time,
                    },
                });
            }
            const priceA = coinATimePricePair === undefined ? 0 : coinATimePricePair[1];
            const priceB = coinBTimePricePair === undefined ? 0 : coinBTimePricePair[1];
            usdRevenue.push({
                ...revenue,
                usdAmount: new decimal_js_1.Decimal(revenue.coinAAmount)
                    .mul(priceA)
                    .add(new decimal_js_1.Decimal(revenue.coinBAmount).mul(priceB))
                    .toString(),
            });
        }
        else if (["ALPHAFI", "NAVI", "BUCKET", "ALPHALEND"].includes(alphafi_sdk_1.poolInfo[revenue.poolName].parentProtocolName) &&
            "coinAmount" in revenue) {
            const coin = (0, alphafi_sdk_1.coinsInPool)(revenue.poolName);
            const coinTimePricePair = historicalPrices[`${coin}/USD`].find((pair) => {
                return Number(pair[0]) === Number(revenue.time);
            });
            if (!coinTimePricePair) {
                (0, logger_js_1.logError)("Historical price not found for single asset pool", {
                    component: "dailyRevenue",
                    operation: "tokensRevenueToUsdRevenue",
                    context: { poolName: revenue.poolName, coin, time: revenue.time },
                });
            }
            const price = coinTimePricePair === undefined ? 0 : coinTimePricePair[1];
            usdRevenue.push({
                ...revenue,
                usdAmount: new decimal_js_1.Decimal(revenue.coinAmount).mul(price).toString(),
            });
        }
        else if (alphafi_sdk_1.poolInfo[revenue.poolName].strategyType === "AUTOBALANCE-LIQUIDITY-POOL") {
            // if ("coinName" in revenue) {
            //   // BLUEFIN AUTOBALANCE POOLS NEW
            //   const coinTimePricePair = historicalPrices[
            //     `${revenue.coinName}/USD`
            //   ].find((pair) => {
            //     return Number(pair[0]) === Number(revenue.time);
            //   });
            //   if (!coinTimePricePair) {
            //     logError(
            //       "Historical price not found for autobalance liquidity pool",
            //       {
            //         component: "dailyRevenue",
            //         operation: "tokensRevenueToUsdRevenue",
            //         context: {
            //           poolName: revenue.poolName,
            //           coin: revenue.coinName,
            //           time: revenue.time,
            //         },
            //       },
            //     );
            //   }
            //   const price =
            //     coinTimePricePair === undefined ? 0 : coinTimePricePair[1];
            //   usdRevenue.push({
            //     ...revenue,
            //     usdAmount: new Decimal(revenue.coinAmount).mul(price).toString(),
            //   });
            // }
            if ("coinAmount" in revenue) {
                // BLUEFIN AUTOBALANCE POOLS OLD
                const coinTimePricePair = historicalPrices[`BLUE/USD`].find((pair) => {
                    return Number(pair[0]) === Number(revenue.time);
                });
                if (!coinTimePricePair) {
                    (0, logger_js_1.logError)("Historical price not found for autobalance liquidity pool", {
                        component: "dailyRevenue",
                        operation: "tokensRevenueToUsdRevenue",
                        context: {
                            poolName: revenue.poolName,
                            coin: "BLUE/USD",
                            time: revenue.time,
                        },
                    });
                }
                const price = coinTimePricePair === undefined ? 0 : coinTimePricePair[1];
                usdRevenue.push({
                    ...revenue,
                    usdAmount: new decimal_js_1.Decimal(revenue.coinAmount).mul(price).toString(),
                });
            }
            else if ("coins" in revenue) {
                // BLUEFIN AUTOBALANCE POOLS NEW
                let usdAmount = new decimal_js_1.Decimal(0);
                for (const coinName in revenue.coins) {
                    const coinTimePricePair = historicalPrices[`${coinName}/USD`].find((pair) => {
                        return Number(pair[0]) === Number(revenue.time);
                    });
                    if (!coinTimePricePair) {
                        (0, logger_js_1.logError)("Historical price not found for autobalance liquidity pool", {
                            component: "dailyRevenue",
                            operation: "tokensRevenueToUsdRevenue",
                            context: {
                                poolName: revenue.poolName,
                                coin: coinName,
                                time: revenue.time,
                            },
                        });
                        continue;
                    }
                    const price = coinTimePricePair[1];
                    const coinAmount = new decimal_js_1.Decimal(revenue.coins[coinName] ?? 0);
                    usdAmount = usdAmount.add(coinAmount.mul(price));
                }
                usdRevenue.push({
                    ...revenue,
                    usdAmount: usdAmount.toString(),
                });
            }
        }
        else {
            (0, logger_js_1.logError)("Unhandled parent protocol for revenue conversion", {
                component: "dailyRevenue",
                operation: "tokensRevenueToUsdRevenue",
                context: { poolName: revenue.poolName, revenue },
            });
            throw new Error("Unhandled Parent Protocol");
        }
    });
    await Promise.all(promises);
    return usdRevenue;
}
async function fetchLastSevenDaysRevenue() {
    const revenueObjects = await fetchDayRevenue({
        startTime: (0, TVL_js_1.getStartOfDayGMT)(Date.now() - 7 * 24 * 60 * 60 * 1000),
        endTime: getEndOfDayGMT(Date.now() - 24 * 60 * 60 * 1000),
    });
    return tokensRevenueToUsdRevenue(revenueObjects);
}
// TODO: Function to enable TTL and set ttl in the table
async function putDailyRevenueToDynamoDB(params) {
    const tableName = params.tableName
        ? params.tableName
        : DAILY_REVENUE_TABLE_NAME;
    const ddbClient = params.ddbClient
        ? params.ddbClient
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    if (!tableName) {
        (0, logger_js_1.logError)("Daily revenue table name not configured", {
            component: "dailyRevenue",
            operation: "putDailyRevenueToDynamoDB",
            context: {
                message: "set DAILY_REVENUE_TABLE_NAME as env variable or pass tableName in params",
            },
        });
        throw new Error("table name not found");
    }
    const items = params.usdRevenue.map((revenue) => {
        return {
            ...revenue,
            poolName: String(revenue.poolName),
            ttl: Math.floor(revenue.time / 1000) + 8 * 24 * 60 * 60,
        };
    });
    let inputItemsLength = 0;
    while (items.length > 0) {
        // DynamoDB BatchWrite supports a max of 25 items per batch
        const batch = items.splice(0, 25);
        inputItemsLength += batch.length;
        // Prepare the batch of items for BatchWriteItem
        const writeRequests = batch.map((item) => {
            if ("coinAmount" in item) {
                return {
                    PutRequest: {
                        Item: {
                            poolName: item.poolName, // Partition key
                            time: item.time, // Sort key
                            ttl: item.ttl, // TTL attribute
                            usdAmount: item.usdAmount,
                            coinAmount: item.coinAmount,
                        },
                    },
                };
            }
            else if ("coinAAmount" in item) {
                return {
                    PutRequest: {
                        Item: {
                            poolName: item.poolName, // Partition key
                            time: item.time, // Sort key
                            ttl: item.ttl, // TTL attribute
                            usdAmount: item.usdAmount,
                            coinAAmount: item.coinAAmount,
                            coinBAmount: item.coinBAmount,
                        },
                    },
                };
            }
            else if ("coins" in item) {
                return {
                    PutRequest: {
                        Item: {
                            poolName: item.poolName, // Partition key
                            time: item.time, // Sort key
                            ttl: item.ttl, // TTL attribute
                            usdAmount: item.usdAmount,
                            coins: item.coins,
                        },
                    },
                };
            }
            else {
                (0, logger_js_1.logError)("Unexpected item format in batch write", {
                    component: "dailyRevenue",
                    operation: "putDailyRevenueToDynamoDB",
                    context: { item },
                });
                throw new Error("Unexpected item");
            }
        });
        const params = {
            RequestItems: {
                [tableName]: writeRequests,
            },
        };
        try {
            let unprocessedItems = undefined;
            // Retry unprocessed items until all are processed
            do {
                const response = await ddbDocClient.send(new lib_dynamodb_1.BatchWriteCommand(params));
                // Check if there are any unprocessed items
                unprocessedItems = response.UnprocessedItems;
                if (unprocessedItems && Object.keys(unprocessedItems).length > 0) {
                    (0, logger_js_1.logInfo)("Retrying unprocessed items in daily revenue batch write", {
                        component: "dailyRevenue",
                        operation: "putDailyRevenueToDynamoDB",
                        context: {
                            unprocessedItemsCount: Object.keys(unprocessedItems).length,
                        },
                    });
                    params.RequestItems = unprocessedItems; // Reassign unprocessed items to retry
                }
            } while (unprocessedItems && Object.keys(unprocessedItems).length > 0);
        }
        catch (err) {
            (0, logger_js_1.logError)("BatchWriteCommand failed in daily revenue insertion", {
                component: "dailyRevenue",
                operation: "putDailyRevenueToDynamoDB",
                error: err instanceof Error ? err : new Error(String(err)),
            });
        }
    }
    (0, logger_js_1.logInfo)("Daily revenue items processing completed", {
        component: "dailyRevenue",
        operation: "putDailyRevenueToDynamoDB",
        context: { itemsProcessed: inputItemsLength },
    });
}
async function getDailyRevenueDataFromDynamoDB(params) {
    const tableName = params.tableName
        ? params.tableName
        : DAILY_REVENUE_TABLE_NAME;
    const ddbClient = params.ddbClient
        ? params.ddbClient
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    const keys = params.poolNames ? params.poolNames : Object.keys(alphafi_sdk_1.poolInfo);
    const commands = keys.map((key) => {
        const command = new client_dynamodb_1.QueryCommand({
            TableName: tableName,
            KeyConditionExpression: "poolName = :poolName",
            ExpressionAttributeValues: {
                ":poolName": { S: key },
            },
        });
        return command;
    });
    try {
        let items = [];
        for (const command of commands) {
            const response = await ddbDocClient.send(command);
            if (response.Items)
                items = items.concat(response.Items);
        }
        return items;
    }
    catch (error) {
        (0, logger_js_1.logError)("Failed to fetch daily revenue items by pool name", {
            component: "dailyRevenue",
            operation: "getDailyRevenueDataFromDynamoDB",
            error: error instanceof Error ? error : new Error(String(error)),
        });
        throw error;
    }
}
async function getDailyRevenueLastDateFromDynamoDB(params) {
    const tableName = params.tableName
        ? params.tableName
        : DAILY_REVENUE_TABLE_NAME;
    const ddbClient = params.ddbClient
        ? params.ddbClient
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const alphaDailyRevenue = await getDailyRevenueDataFromDynamoDB({
        tableName,
        ddbClient,
        poolNames: ["ALPHA"],
    });
    const highestTime = Number(alphaDailyRevenue
        .map((o) => o.time.N)
        .sort((a, b) => Number(b) - Number(a))[0]);
    return highestTime;
}
function getEndOfDayGMT(timestamp) {
    const date = new Date(timestamp);
    date.setUTCHours(23, 59, 59, 999); // Set to the last millisecond of the day
    return date.getTime();
}
//# sourceMappingURL=dailyRevenue.js.map